import styled from "styled-components";
import { Divider } from "@mui/material";

import { breakpoints } from "@/styles/breakpoints";

export const StyledFooterDivider = styled(Divider)`
    border-color: var(--color-primary-fg);
    border-width: 1px;
    height: 12px;
    align-self: center;
`;

export const StyledFooter = styled.footer`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 270px;
    background-color: var(--color-primary);
    @media ${breakpoints.mdMax} {
        height: 250px;
    }
    @media ${breakpoints.sm} {
        height: 200px;
    }

    .logo {
        display: flex;
        padding: 0;

        svg {
            @media ${breakpoints.sm} {
                width: 150px;
            }
        }

        &:hover {
            background-color: unset;
        }
    }

    .footerDividerText {
        cursor: pointer;
    }

    .footerText,
    .footerDividerText {
        margin-top: 0;
        margin-bottom: 0;
        font-size: var(--size-16);
        font-style: normal;
        font-weight: normal;
        line-height: 22px;
        color: var(--color-primary-fg);
        letter-spacing: -0.01em;
        @media ${breakpoints.sm} {
            font-size: var(--size-14);
        }
    }
`;
